var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetchWrapper from '../fetchWrapper';
import { standardizeHubError, getHubUrl } from './utils';
import { globalRequestTracking } from '../../utils/global-request-tracking';
import { mapSnakeKeysToCamelKeys } from '../../utils/case-conversion';
// TODO: rework this at the redux level
// eslint-disable-next-line @typescript-eslint/no-unused-vars, import/no-mutable-exports
export var fetchWithCatch = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return undefined;
};
export var reportError = function (linkError, fireClientEvent, setError) {
    fireClientEvent('error', linkError);
    setError({
        errorType: linkError.type,
        errorCode: linkError.code,
        errorMsg: linkError.message,
        pendingRetry: linkError.pendingRetry,
    });
};
function getResponseJson(args, overrides) {
    if (overrides === void 0) { overrides = []; }
    return __awaiter(this, void 0, void 0, function () {
        var foundOverride, response, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (process.env.STORYBOOK) {
                        foundOverride = overrides.find(function (_a) {
                            var check = _a.check;
                            return check.apply(void 0, args);
                        });
                        if (foundOverride)
                            return [2 /*return*/, foundOverride.response];
                        // If no override is found in storybook definition, just hang forever
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        return [2 /*return*/, new Promise(function (resolve) { })];
                    }
                    return [4 /*yield*/, fetchWrapper.apply(void 0, args)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, json];
            }
        });
    });
}
export function setFetchWithCatch(_a) {
    var _this = this;
    var fireClientEvent = _a.fireClientEvent, setError = _a.setError, navigateToError = _a.navigateToError, overrides = _a.overrides;
    fetchWithCatch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var time, delta, interval, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        globalRequestTracking.outboudRequestsCount++;
                        time = 0;
                        delta = 5000;
                        interval = setInterval(function () {
                            time += delta;
                            // console.log(`request is taking long (${time / 1000}s)`, ...args); // eslint-disable-line
                        }, delta);
                        return [4 /*yield*/, getResponseJson(args, overrides)];
                    case 1:
                        json = _a.sent();
                        if (json.error) {
                            reportError(standardizeHubError(json.error), fireClientEvent, setError);
                            navigateToError();
                        }
                        globalRequestTracking.outboudRequestsCount--;
                        clearInterval(interval);
                        return [2 /*return*/, json];
                }
            });
        });
    };
    return fetchWithCatch;
}
export var requestGet = function (mode, path, headers) {
    if (headers === void 0) { headers = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchWithCatch("".concat(getHubUrl(mode)).concat(path), {
                        method: 'GET',
                        headers: headers,
                    })];
                case 1:
                    json = _a.sent();
                    if (!json || json.error)
                        return [2 /*return*/, []];
                    return [2 /*return*/, mapSnakeKeysToCamelKeys(json.data)];
            }
        });
    });
};
